module.exports = __webpack_public_path__ + "static/media/opensea_icon_logo.137beca2.svg";